import { apiRequest } from '../../../app/api';

export const listConsignments = (query = {}) => {
  const p = new URLSearchParams();
  if (query.q) p.set('q', query.q);
  if (query.status) p.set('status', query.status);
  if (query.sort) p.set('sort', query.sort);
  if (query.order) p.set('order', query.order);
  if (query.page != null) p.set('page', String(query.page));
  if (query.page_size != null) p.set('page_size', String(query.page_size));
  const qs = p.toString();
  return apiRequest(`/consignments${qs ? `?${qs}` : ''}`);
};

export const createConsignment = (payload) =>
  apiRequest('/consignments', { method: 'POST', body: JSON.stringify(payload) });

export const getConsignment = (id) =>
  apiRequest(`/consignments/${id}`);

export const updateConsignment = (id, payload) =>
  apiRequest(`/consignments/${id}`, { method: 'PUT', body: JSON.stringify(payload) });

export const deleteConsignment = (id) =>
  apiRequest(`/consignments/${id}`, { method: 'DELETE' });

export const allocateConsignment = (consignmentId, payload) =>
  apiRequest(`/consignments/${consignmentId}/allocate`, { method: 'POST', body: JSON.stringify(payload) });

export const finalizeConsignment = (consignmentId, payload) =>
  apiRequest(`/consignments/${consignmentId}/finalize`, { method: 'POST', body: JSON.stringify(payload) });

export const renewConsignment = (consignmentId, payload) =>
  apiRequest(`/consignments/${consignmentId}/renew`, { method: 'POST', body: JSON.stringify(payload) });

export const listConsignmentItems = (consignmentId) =>
  apiRequest(`/consignments/${consignmentId}/items`);

export const addConsignmentItem = (consignmentId, payload) =>
  apiRequest(`/consignments/${consignmentId}/items`, { method: 'POST', body: JSON.stringify(payload) });

export const updateConsignmentItem = (consignmentId, itemId, payload) =>
  apiRequest(`/consignments/${consignmentId}/items/${itemId}`, { method: 'PUT', body: JSON.stringify(payload) });

export const removeConsignmentItem = (consignmentId, itemId, payload = {}) =>
  apiRequest(`/consignments/${consignmentId}/items/${itemId}`, {
    method: 'DELETE',
    body: JSON.stringify(payload),
  });

export const getConsignmentSettings = () =>
  apiRequest('/consignments/settings');

export const saveConsignmentSettings = (payload) =>
  apiRequest('/consignments/settings', { method: 'PUT', body: JSON.stringify(payload) });
